// prefer default export if available
var preferDefault = function preferDefault(m) {
  return m && m.default || m;
};

exports.components = {
  "component---src-pages-404-mdx": function componentSrcPages404Mdx() {
    return import("./../../src/pages/404.mdx"
    /* webpackChunkName: "component---src-pages-404-mdx" */
    );
  },
  "component---src-pages-akcie-jsx": function componentSrcPagesAkcieJsx() {
    return import("./../../src/pages/akcie.jsx"
    /* webpackChunkName: "component---src-pages-akcie-jsx" */
    );
  },
  "component---src-pages-index-jsx": function componentSrcPagesIndexJsx() {
    return import("./../../src/pages/index.jsx"
    /* webpackChunkName: "component---src-pages-index-jsx" */
    );
  },
  "component---src-pages-kontakt-mdx": function componentSrcPagesKontaktMdx() {
    return import("./../../src/pages/kontakt.mdx"
    /* webpackChunkName: "component---src-pages-kontakt-mdx" */
    );
  },
  "component---src-pages-mapa-mdx": function componentSrcPagesMapaMdx() {
    return import("./../../src/pages/mapa.mdx"
    /* webpackChunkName: "component---src-pages-mapa-mdx" */
    );
  },
  "component---src-pages-newsletter-mdx": function componentSrcPagesNewsletterMdx() {
    return import("./../../src/pages/newsletter.mdx"
    /* webpackChunkName: "component---src-pages-newsletter-mdx" */
    );
  },
  "component---src-pages-newsletter-ok-jsx": function componentSrcPagesNewsletterOkJsx() {
    return import("./../../src/pages/newsletter-ok.jsx"
    /* webpackChunkName: "component---src-pages-newsletter-ok-jsx" */
    );
  },
  "component---src-pages-newsletter-potvrdenie-jsx": function componentSrcPagesNewsletterPotvrdenieJsx() {
    return import("./../../src/pages/newsletter-potvrdenie.jsx"
    /* webpackChunkName: "component---src-pages-newsletter-potvrdenie-jsx" */
    );
  },
  "component---src-pages-o-paralelnej-polis-mdx": function componentSrcPagesOParalelnejPolisMdx() {
    return import("./../../src/pages/o-paralelnej-polis.mdx"
    /* webpackChunkName: "component---src-pages-o-paralelnej-polis-mdx" */
    );
  },
  "component---src-pages-podmienky-pouzivania-mdx": function componentSrcPagesPodmienkyPouzivaniaMdx() {
    return import("./../../src/pages/podmienky-pouzivania.mdx"
    /* webpackChunkName: "component---src-pages-podmienky-pouzivania-mdx" */
    );
  },
  "component---src-pages-rychlokurz-bezpecnosti-jsx": function componentSrcPagesRychlokurzBezpecnostiJsx() {
    return import("./../../src/pages/rychlokurz-bezpecnosti.jsx"
    /* webpackChunkName: "component---src-pages-rychlokurz-bezpecnosti-jsx" */
    );
  },
  "component---src-pages-zapoj-sa-adopcia-mdx": function componentSrcPagesZapojSaAdopciaMdx() {
    return import("./../../src/pages/zapoj-sa/adopcia.mdx"
    /* webpackChunkName: "component---src-pages-zapoj-sa-adopcia-mdx" */
    );
  },
  "component---src-pages-zapoj-sa-cudzie-jazyky-mdx": function componentSrcPagesZapojSaCudzieJazykyMdx() {
    return import("./../../src/pages/zapoj-sa/cudzie-jazyky.mdx"
    /* webpackChunkName: "component---src-pages-zapoj-sa-cudzie-jazyky-mdx" */
    );
  },
  "component---src-pages-zapoj-sa-index-mdx": function componentSrcPagesZapojSaIndexMdx() {
    return import("./../../src/pages/zapoj-sa/index.mdx"
    /* webpackChunkName: "component---src-pages-zapoj-sa-index-mdx" */
    );
  },
  "component---src-pages-zapoj-sa-obsah-mdx": function componentSrcPagesZapojSaObsahMdx() {
    return import("./../../src/pages/zapoj-sa/obsah.mdx"
    /* webpackChunkName: "component---src-pages-zapoj-sa-obsah-mdx" */
    );
  },
  "component---src-pages-zapoj-sa-ok-mdx": function componentSrcPagesZapojSaOkMdx() {
    return import("./../../src/pages/zapoj-sa/ok.mdx"
    /* webpackChunkName: "component---src-pages-zapoj-sa-ok-mdx" */
    );
  },
  "component---src-pages-zapoj-sa-podpora-mdx": function componentSrcPagesZapojSaPodporaMdx() {
    return import("./../../src/pages/zapoj-sa/podpora.mdx"
    /* webpackChunkName: "component---src-pages-zapoj-sa-podpora-mdx" */
    );
  },
  "component---src-pages-zapoj-sa-program-mdx": function componentSrcPagesZapojSaProgramMdx() {
    return import("./../../src/pages/zapoj-sa/program.mdx"
    /* webpackChunkName: "component---src-pages-zapoj-sa-program-mdx" */
    );
  },
  "component---src-pages-zapoj-sa-vlastny-napad-mdx": function componentSrcPagesZapojSaVlastnyNapadMdx() {
    return import("./../../src/pages/zapoj-sa/vlastny-napad.mdx"
    /* webpackChunkName: "component---src-pages-zapoj-sa-vlastny-napad-mdx" */
    );
  },
  "component---src-templates-blog-jsx": function componentSrcTemplatesBlogJsx() {
    return import("./../../src/templates/blog.jsx"
    /* webpackChunkName: "component---src-templates-blog-jsx" */
    );
  },
  "component---src-templates-post-jsx": function componentSrcTemplatesPostJsx() {
    return import("./../../src/templates/post.jsx"
    /* webpackChunkName: "component---src-templates-post-jsx" */
    );
  },
  "component---src-templates-tag-jsx": function componentSrcTemplatesTagJsx() {
    return import("./../../src/templates/tag.jsx"
    /* webpackChunkName: "component---src-templates-tag-jsx" */
    );
  }
};